export enum MAIN_NAVIGATION_ACTIONS {
  SET_CONTAINER_REQUEST = 'SET_CONTAINER_REQUEST',
  SET_CONTAINER_FULFILLED = 'SET_CONTAINER_FULFILLED',
}
